import { useNavigate } from 'react-router-dom';
import type { AIConversation } from '../types/contracts';
import { CHANNEL_ICON, timeAgo } from '../lib/format';
import { TemperatureBadge } from './LeadScore';

export function ConversationList({ conversations, title = 'محادثات مباشرة' }: { conversations: AIConversation[]; title?: string }) {
  const navigate = useNavigate();
  return (
    <section className="rounded-2xl bg-white border border-gray-100">
      <header className="px-5 py-4 border-b border-gray-50 flex items-center justify-between">
        <h2 className="text-sm font-black text-gray-900">{title}</h2>
        <span className="text-[11px] text-gray-400">{conversations.length} نشطة</span>
      </header>
      <ul className="divide-y divide-gray-50">
        {conversations.map((c) => (
          <li key={c.id}>
            <button
              type="button"
              onClick={() => navigate(`/intelligence/conversations/${c.id}`, { preventScrollReset: true })}
              className="w-full text-start px-5 py-3.5 hover:bg-gray-50/60 transition-colors flex items-center gap-3"
            >
              <span className="relative shrink-0 w-10 h-10 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center text-sm font-black">
                {(c.customer_name ?? '?').trim().charAt(0) || '?'}
                {c.online && <span className="absolute bottom-0 end-0 w-2.5 h-2.5 rounded-full bg-emerald-500 border-2 border-white" />}
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center gap-2">
                  <span className="text-sm font-bold text-gray-900 truncate">{c.customer_name}</span>
                  <span className="text-[11px] text-gray-400 truncate">{c.business_name}</span>
                </span>
                <span className="flex items-center gap-1.5 text-[11px] text-gray-500">
                  <i className={CHANNEL_ICON[c.channel]} />
                  {c.online ? <span className="text-emerald-600 font-semibold">● متصل</span> : <span>غير متصل</span>}
                </span>
                <span className="block text-xs text-gray-600 truncate mt-0.5">{c.last_message}</span>
              </span>
              <span className="shrink-0 text-end space-y-1">
                <TemperatureBadge temperature={c.temperature} />
                <span className="block text-[11px] text-gray-500">
                  {c.handler === 'ai' ? `المساعد يرد — ثقة ${c.ai_confidence ?? 0}%` : c.handler === 'human' ? 'يتولاها موظف' : 'متوقفة'}
                </span>
                <span className="block text-[10px] text-gray-400">{timeAgo(c.last_message_at ?? (c as unknown as { last_activity_at?: string }).last_activity_at ?? new Date().toISOString())}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
